var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',[(_vm.show)?_c('v-overlay',{attrs:{"color":"#ffffff","opacity":"0.9"}},[_c('v-progress-circular',{attrs:{"value":_vm.value,"color":"primary","size":"64","width":"6"}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }